import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../app.css';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav
            className={`fixed top-0 right-0 left-0 w-full z-50 transition-all duration-300 ${
                isScrolled ? 'bg-white shadow-lg bg-opacity-80' : 'bg-transparent'
            }`}
        >
            <div className="container mx-auto px-4 py-4 flex justify-between items-center">
                {/* Brand Logo */}
                <div className="text-white text-2xl font-bold tracking-wider ml-4">
                    <span className="relative inline-block">
                        <Link
                            to="/"
                            className="text-white hover:text-[#3370C9] transition-colors duration-300 relative group cursor-pointer"
                        >
                            <img src="/assets/hisaab_logo.png" alt="HISAAB" className="h-8" />
                        </Link>
                    </span>
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden text-black focus:outline-none"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>

                {/* Desktop Navigation Links */}
                <div className="hidden md:flex space-x-8">
                    <Link
                        to="/"
                        className="text-primary font-bold transition-colors duration-300 relative group cursor-pointer mx-4"
                    >
                        Home
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"></span>
                    </Link>
                    <Link
                        to="/products"
                        className="text-primary font-bold transition-colors duration-300 relative group cursor-pointer mx-4"
                    >
                        Our Products
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"></span>
                    </Link>
                    <Link
                        to="/become-merchant"
                        className="text-primary font-bold transition-colors duration-300 relative group cursor-pointer mx-4"
                    >
                        Become Merchant
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"></span>
                    </Link>
                    <Link
                        to="/about-us"
                        className="text-primary font-bold transition-colors duration-300 relative group cursor-pointer mx-4"
                    >
                        About Us
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"></span>
                    </Link>
                    {/* <Link
                        to="/tutorials"
                        className="text-primary font-bold transition-colors duration-300 relative group cursor-pointer mx-4"
                    >
                        Tutorials
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"></span>
                    </Link> */}
                </div>

                {/* Download App Button */}
                <button className="hidden md:block bg-secondary text-white ml-6 mr-4 px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105 shadow-md">
                    Download App
                </button>
            </div>

            {/* Mobile Menu */}
            <div
                className={`md:hidden bg-[#0a1e3a] transition-all duration-300 overflow-hidden ${
                    mobileMenuOpen ? 'max-h-96 shadow-lg' : 'max-h-0'
                }`}
            >
                <div className="container mx-auto px-4 py-2">
                    {['/', '/products', '/become-merchant', '/about-us'].map((path, index) => (
                        <Link
                            key={path}
                            to={path}
                            className="block py-3 text-white transition-colors duration-300 border-b border-[#193763]/30 cursor-pointer"
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            {['Home', 'Our Products', 'Become Merchant', 'About Us'][index]}
                        </Link>
                    ))}
                    <button className="w-full mt-4 mb-2 bg-secondary text-white px-6 py-2 rounded-md transition-all duration-300">
                        Download App
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;